import { render } from "./StudioMessageForm.vue?vue&type=template&id=a5e0b55c&scoped=true"
import script from "./StudioMessageForm.vue?vue&type=script&lang=js"
export * from "./StudioMessageForm.vue?vue&type=script&lang=js"

import "./StudioMessageForm.vue?vue&type=style&index=0&id=a5e0b55c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e0b55c"]])

export default __exports__